import { useCallback, useEffect, useRef, useState } from 'react';

export const useScrollToBottom = () => {
  const [isAtBottom, setIsAtBottom] = useState(true);

  const scrollToBottom = useCallback(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      });
    }
  }, []);

  useEffect(() => {
    const handleScrollOrResize = () => {
      const currentScrollLocation = document.documentElement.scrollTop;
      const scrollableContentHeight = document.documentElement.scrollHeight;
      const viewportHeight = window.innerHeight;
      const buffer = 35;

      const isAtBottom =
        scrollableContentHeight - viewportHeight <=
        currentScrollLocation + buffer;
      setIsAtBottom(isAtBottom);
    };

    document.addEventListener('scroll', handleScrollOrResize, {
      passive: true
    });

    window.addEventListener('resize', handleScrollOrResize, {
      passive: true
    });

    return () => {
      document.removeEventListener('scroll', handleScrollOrResize);
      window.removeEventListener('resize', handleScrollOrResize);
    };
  }, []);

  return {
    isAtBottom,
    scrollToBottom
  };
};
